export default __webpack_public_path__ + "static/media/Game_Track.374f20c4.svg";